export default {"src":"/_next/static/media/logo-autopass-for-business.20403746.svg","height":15,"width":148,"blurWidth":0,"blurHeight":0};